/**
 * What's Next app — /apps/whats-next/*
 *
 * One job: a person wants to start each day clear on the three things that
 * matter and with time set aside for the one that moves them forward. Its
 * first screen is Morning Boot (roadmap S-16); the Get Clear exercises join
 * later as further screens over the same items. Offered in personal
 * workspaces (ruling R18).
 */

import { Navigate, Route, Routes } from 'react-router-dom';
import { getAppDefinition } from '../registry';
import { RequireAppAccess } from '../RequireAppAccess';
import MorningBootScreen from './MorningBootScreen';

export default function WhatsNextApp() {
  const app = getAppDefinition('whats-next')!;
  return (
    <RequireAppAccess app={app}>
      <Routes>
        <Route index element={<MorningBootScreen />} />
        <Route path="*" element={<Navigate to="/apps/whats-next" replace />} />
      </Routes>
    </RequireAppAccess>
  );
}
